import React from 'react';

import isIsolatedMode from '../../helpers/isIsolatedMode';
import Blokkendoos from '../../services/blokkendoos';
import IsolationHeader from '../IsolationHeader';

function withIsolation(Component) {
  if (!isIsolatedMode()) return Component;

  return props => {
    const [signupFor, setSignupFor] = React.useState(null);

    const [jReady, setJReady] = React.useState(false);
    React.useEffect(() => {
      import('jquery').then(module => {
        window.$ = module.default;
        setSignupFor(new Blokkendoos().getSignupFor());
        setJReady(true);
      });
    }, []);
    if (!jReady) return 'loading jQuery...';

    return (
      <React.StrictMode>
        <IsolationHeader setUserFlow={setSignupFor} />
        <Component {...props} signupFor={signupFor} />
      </React.StrictMode>
    );
  };
}

export default withIsolation;
